import { useI18n } from './i18n';
import './App.css';

// Discreet language switch, pinned to the sheet's right edge.
// Letters stand at 90° — the right angle, again.
export default function LangSwitch() {
  const { locale, setLocale } = useI18n();
  return (
    <div className="langswitch" role="group" aria-label="Langue / Language">
      <button
        type="button"
        className={'langswitch-btn' + (locale === 'fr' ? ' is-active' : '')}
        aria-pressed={locale === 'fr'}
        aria-label="Français"
        onClick={() => setLocale('fr')}
      >
        FR
      </button>
      <button
        type="button"
        className={'langswitch-btn' + (locale === 'en' ? ' is-active' : '')}
        aria-pressed={locale === 'en'}
        aria-label="English"
        onClick={() => setLocale('en')}
      >
        EN
      </button>
      <button
        type="button"
        className={'langswitch-btn' + (locale === 'ro' ? ' is-active' : '')}
        aria-pressed={locale === 'ro'}
        aria-label="Română"
        onClick={() => setLocale('ro')}
      >
        RO
      </button>
    </div>
  );
}
